import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiFormLabel from "@mui/material/FormLabel";
export const FormLabel = props => {
  const {
    children,
    id,
    className,
    component,
    ...otherProps
  } = props;
  return children ? /*#__PURE__*/React.createElement(MuiFormLabel, _extends({
    component: component || "label",
    id: `${id}-label`,
    className: `prmbl-formLabel ${className}`
  }, otherProps), children) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default FormLabel;